import React, { useState } from 'react'
import { Popover, ArrowContainer } from 'react-tiny-popover'

import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'

import './styles'

ARROW_SIZE = 8
ARROW_COLOR = '#F0F0F0'

export default Warning = ({ children }) ->
  return null unless children

  [isOpen, setIsOpen] = useState false
  [isPreview, setIsPreview] = useState false

  onClosePopover = ->
    setIsOpen false
    setIsPreview false

  onTogglePopover = -> setIsOpen (prevState) -> not prevState

  popoverContent = ({ position, childRect, popoverRect }) ->
    <ArrowContainer
      arrowSize={ARROW_SIZE}
      arrowColor={ARROW_COLOR}
      className='WarningPopover'
      {...{ position, childRect, popoverRect }}
    >
      <div className="content">
        <div className="header-container">
          <h5 className="header">Warnings</h5>
          { <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={onClosePopover}
            >
              <span aria-hidden="true">&times;</span>
            </button> if isOpen }
        </div>
        {children}
      </div>
    </ArrowContainer>

  <div
    className="Warning"
    onMouseEnter={() => setIsPreview(true)}
    onMouseLeave={() => setIsPreview(false)}
  >
    <Popover
      isOpen={isPreview or isOpen}
      onClickOutside={onClosePopover}
      positions={['left', 'bottom', 'right']}
      padding={4}
      content={(content) -> popoverContent content}
    >
      <div
        className="icon-container"
        onClick={onTogglePopover}
      >
        <WarningIcon className="warning-icon" />
      </div>
    </Popover>
  </div>
